export default (() => {

  const triggerEvent = (type, el)=>{
    const event = new Event(type, { bubbles: true, cancelable: true });
    el.dispatchEvent(event)
  }

  const initCountInput = (component) => {
    const incrementBtn = component.querySelector('[data-increment]')
    const decrementBtn = component.querySelector('[data-decrement]')
    const input = component.querySelector('.form-control')

    if (!incrementBtn || !decrementBtn || !input) return

    incrementBtn.addEventListener('click', handleIncrement)
    decrementBtn.addEventListener('click', handleDecrement)
    updateButtonStates(input)
  }

  const handleIncrement = (event) => {
    const input = event.currentTarget.parentNode.querySelector('.form-control')
    const maxValue = parseInt(input.getAttribute('max')) || Infinity

    if (input.value < maxValue) {
      input.value = parseInt(input.value || 0) + 1
      triggerEvent('change', input);
      triggerEvent('change:increment', input);
      updateButtonStates(input)
    }
  }

  const handleDecrement = (event) => {
    const input = event.currentTarget.parentNode.querySelector('.form-control')
    const minValue = parseInt(input.getAttribute('min')) || 0

    if (input.value > minValue) {
      input.value = parseInt(input.value || 0) - 1
      triggerEvent('change', input);
      triggerEvent('change:decrement', input);
      updateButtonStates(input)
    }
  }

  const updateButtonStates = (input) => {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]')
    const incrementBtn = input.parentNode.querySelector('[data-increment]')
    const minValue = parseInt(input.getAttribute('min')) || 0
    const maxValue = parseInt(input.getAttribute('max')) || Infinity

    decrementBtn.disabled = input.value <= minValue
    incrementBtn.disabled = input.value >= maxValue

    const parent = input.closest('.count-input')
    if (!parent.classList.contains('count-input-collapsible')) return

    const inputValue = incrementBtn.querySelector('[data-count-input-value]')

    if (input.value > 0) {
      parent.classList.remove('collapsed')
      if (inputValue) {
        inputValue.textContent = input.value
      }
    } else {
      parent.classList.add('collapsed')
      if (inputValue) {
        inputValue.textContent = ''
      }
    }
  }

  document.querySelectorAll('.count-input').forEach(initCountInput)

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains('count-input')) {
          initCountInput(node)
        } else if (node.nodeType === 1) {
          node.querySelectorAll('.count-input').forEach(initCountInput)
        }
      })
    })
  })

  observer.observe(document.body, { childList: true, subtree: true })
})()
